export const isValidHotelSchemaRating = (value: unknown): value is number =>
    typeof value === 'number' &&
    Number.isFinite(value) &&
    value >= 0 &&
    value <= 10;

export const buildHotelAggregateRating = (
    ratingValue: unknown,
    reviewCount: number
) => {
    if (
        !isValidHotelSchemaRating(ratingValue) ||
        !Number.isInteger(reviewCount) ||
        reviewCount <= 0
    ) {
        return undefined;
    }

    return {
        '@type': 'AggregateRating' as const,
        ratingValue,
        reviewCount,
        bestRating: 10,
        worstRating: 0,
    };
};

export const getHotelReviewAuthorName = (name?: string | null) =>
    name?.trim() || 'کاربر مهمان';
